module.exports = __webpack_public_path__ + "static/media/3.437c3263.jpg";